import {Application} from "../Application";
import {Ease} from "../core/Animatable";
import {Container} from "../core/Container";
import {IPoint} from "../core/Geom";
import {Callback} from "../core/Reflection";
import {Times} from "../core/Signal";
import {Brad, Xavier, Yadina} from "./Character";

export class Characters extends Container {

    public readonly characterXavier = this.addChild(new Xavier());
    public readonly characterYadina = this.addChild(new Yadina());
    public readonly characterBrad = this.addChild(new Brad());
    public readonly characters = [this.characterXavier, this.characterYadina, this.characterBrad];

    public alignCharacters(...positions: [IPoint, IPoint, IPoint]) {
        this.visible = false;
        for (let i = 0; i < this.characters.length; i++) {
            const character = this.characters[i];
            character.x = positions[i].x;
            character.y = positions[i].y;
            character.scale.set(0.275);
        }
        this.characterBrad.scale.x *= -1;

        // Center characters on the screen while the free play book is hidden
        this.characterXavier.x += 120;
        this.characterYadina.x += 160;
        this.characterBrad.x -= 220;
    }

    public showCharacters(cb?: Callback) {
        this.visible = true;
        this.runCharacters("in", cb);
    }

    public hideCharacters(cb?: Callback) {
        this.runCharacters("out", cb);
    }

    private runCharacters(direction: "in" | "out", cb?: Callback) {
        const speed = 1600;
        const size = Application.instance.size.x;
        const py = -size - this.characterYadina.width;
        const px = py - (this.characterYadina.x - this.characterXavier.x);
        const pb = size + Math.abs(this.characterBrad.width);
        const onComplete = Times(3, () => {
            if (cb) {
                cb();
            }
        });

        const isOut = direction === "out";
        const method = isOut ? "moveXTo" : "moveXFrom";
        if (isOut) {
            this.characterYadina.scale.x *= -1;
            this.characterXavier.scale.x *= -1;
        }

        this.characterYadina.startRun();
        this.characterYadina[method](py, Math.abs(this.characterYadina.x - py) / speed, Ease.none, () => {
            this.characterYadina.stopRun();
            onComplete();
        });
        this.characterXavier.startRun();
        this.characterXavier[method](px, Math.abs(this.characterXavier.x - px) / speed, Ease.none, () => {
            this.characterXavier.stopRun();
            onComplete();
        });
        this.characterBrad[method](pb, Math.abs(this.characterBrad.x - pb) / speed, Ease.none, {
            delay: 0.4,
            onStart: () => {
                if (isOut) {
                    this.characterBrad.scale.x *= -1;
                }
                this.characterBrad.startRun();
            },
            onComplete: () => {
                this.characterBrad.stopRun();
                onComplete();
            },
        });
    }
}
